module.exports = require("./bm.d.ts");